module.exports = __webpack_public_path__ + "img/mobile-screen-1.84d61739.png";